import { render, staticRenderFns } from "./Modifiers.vue?vue&type=template&id=42d3d8ed"
import script from "./Modifiers.vue?vue&type=script&lang=js"
export * from "./Modifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports